/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: tduzggWPyptPHtemkm2DXC

import { createUseGlobalVariants } from "@plasmicapp/react-web";

import { useScreenVariants as useScreenVariantsf56KWdNcjmSj } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: F56kWdNcjmSJ/globalVariant
import { SegmentValue, useSegment } from "./PlasmicGlobalVariant__Segment"; // plasmic-import: qg6OEB-_6RBg/globalVariant
import {
  ThemeOrangeValue,
  useThemeOrange
} from "./PlasmicGlobalVariant__ThemeOrange"; // plasmic-import: 21mZbQtB3lIk/globalVariant
import {
  ThemePurpleDarkValue,
  useThemePurpleDark
} from "./PlasmicGlobalVariant__ThemePurpleDark"; // plasmic-import: PwTMlLBt_8qs/globalVariant

export const _useGlobalVariants = createUseGlobalVariants({
  screen: useScreenVariantsf56KWdNcjmSj,
  segment: useSegment,
  themeOrange: useThemeOrange,
  themePurpleDark: useThemePurpleDark
});
